import React from "react";
import { Box, Container } from "@mui/material";
import MarketingNav from "../components/MarketingNav";

const PublicCommunityPage = ({ children }) => (
  <>
    <MarketingNav />
    <Box sx={{ pt: { xs: 10, md: 12 }, pb: 8, minHeight: "100vh" }}>
      <Container maxWidth="lg">{children}</Container>
    </Box>
  </>
);

export default PublicCommunityPage;
